import { useState, useContext, useEffect } from 'react';
import CardHeader from '../../../components/CardHeader';
import useLoading from '../../../../Hooks/useLoading';
import { CompanyContext } from '../../../../Contexts/CompanyContext';
import { toast } from "react-toastify"; // substituir
import Loader from '../../../../Components/Shared/Loader';
import CollapseLinesComponent from '../../../components/OpportunitiesPanels/CollapseLines'; // refazer 
import { IOpportunitiesProjects, OpportunityDashborardHistoricVO } from '../../../../Interfaces/IOpportunitiesPanels';
import { useParams } from 'react-router-dom'
import { IResponseProps } from '../../../../Interfaces/IResponseProps';//--
import { GetOpportunitiesPanelsByIdAPI } from '../../../../API/OpportunitiesPanelsAPI';
import { AuthContext } from '../../../../Contexts/AuthContext'//--
import { OpportunitiesPanelsModel, OpportunitiesPanelsCommentsModel } from '../../../../Models/OpportunitiesPanelsModel';
import './styles.css';
import CommentsPanelsComponent from '../../../components/OpportunitiesPanels/CommentsPanelsComponent'; //refazer
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { CreateOpportunityPanelCommentsAPI, DeleteOpportunitiyPanelCommentsAPI, EditOpportunityPanelCommentsAPI, GetAllCommentsByOpportunitiesPanelsIdAPI } from '../../../../API/OpportunityPanelCommentsAPI';
import { GetAllGroupedByOrganismAPI } from '../../../../API/GrantsAPI';
import { Select, Typography, Input, Button, Form } from 'antd';

interface FormSubmitProps {
    comment: string;
    result: string;
}

const LinesPresentation = () => {
    const { opportunitiesPanelsId } = useParams();
    const { loading, toggleLoading } = useLoading();
    const { userEmail } = useContext(AuthContext);
    const { company } = useContext(CompanyContext);
    const [opportunitiesPanels, setOpportunitiesPanels] = useState<OpportunitiesPanelsModel>({} as OpportunitiesPanelsModel);
    const [grantsLines, setGrantsLines] = useState<OpportunityDashborardHistoricVO>();
    const [projectsByGrant, setProjectsByGrant] = useState<IOpportunitiesProjects>();
    const [result, setResult] = useState<string>("2");
    // const [resultOld, setResultOld] = useState<string>("0");
    const [name, setName] = useState<string>("");
    const [opportunitiesComments, setOpportunitiesComments] = useState<OpportunitiesPanelsCommentsModel[]>([]);
    const [isAsc, setIsAsc] = useState<boolean>(true);
    const { TextArea } = Input;
    const [form] = Form.useForm();

    const schema = yup.object().shape({
        comment: yup.string().max(2000, "Limite de caracteres excedido! Limite: 2000 Caracteres").required("Por favor, insira um Nome válido!")
    });

    const { register, handleSubmit, setValue, formState: { errors }, control } = useForm<FormSubmitProps>({
        resolver: yupResolver(schema)
    });

    const getAllGroupedByOrganism = async () => {
        try {
            toggleLoading(true);
            await GetAllGroupedByOrganismAPI(company.id, opportunitiesPanelsId ?? "").then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setGrantsLines(resp.data);

                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }


    const setAllOpportunitiesPanelsInformations = (opportunitiesPanel: OpportunitiesPanelsModel) => {
        setOpportunitiesPanels(opportunitiesPanel);
        // setResultOld(opportunitiesPanel.result.toString());
        setResult(opportunitiesPanel.result.toString());
        setName(opportunitiesPanel.name);
    }

    const getOpportunitiesPanelsInfo = async (id: string) => {
        try {
            toggleLoading(true);

            await GetOpportunitiesPanelsByIdAPI(id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    const opportunities: OpportunitiesPanelsModel = resp.data;
                    if (opportunities) {
                        setAllOpportunitiesPanelsInformations(opportunities);
                    }
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const Submit = async (data: any) => {
        try {
            toggleLoading(true);
            let comment = data.comment ?? "";
            let submitResult = result ?? "";
            let id = opportunitiesPanelsId ?? "";
            let CreateComment = await CreateOpportunityPanelCommentsAPI(id, comment, submitResult, userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success('Comentario cadastrado com sucesso');
                }
            })
            // let EditOpportunitiesPanelsResult = await EditOpportunitiesPanelsAPI(id, result, userEmail).then((resp: IResponseProps) => {
            //     if (resp.statusCode === 200) {
            //         toast.success('Resultado do painel alterado com sucesso');
            //     }
            // })
            // await Promise.all([CreateComment, EditOpportunitiesPanelsResult]).finally(() => {
            //     setValue("comment", "");
            //     setValue("result", "0");
            //     getOpportunitiesPanelsInfo(opportunitiesPanelsId ?? "");
            //     getAllCommentsByPanel();
            //     toggleLoading(false);
            // });
        } catch (error: any) {
            setValue("comment", "");
            setValue("result", "0");
            toast.error(error);
            toggleLoading(false);
        }
        finally {
            setValue("comment", "");
            setValue("result", "0");
            getOpportunitiesPanelsInfo(opportunitiesPanelsId ?? "");
            getAllCommentsByPanel();
            toggleLoading(false);
        }
    }

    const editComment = async (id: string, comment: string) => {
        try {
            toggleLoading(true);
            await EditOpportunityPanelCommentsAPI(id, comment, userEmail).then((resp: IResponseProps) => {
                toast.success('Comentario editado com sucesso');
            }).finally(() => {
                toggleLoading(false);
                const editComment = opportunitiesComments.map(x => {
                    if (x.id === id) {
                        x.comments = comment;
                    }
                    return x;
                })
                setOpportunitiesComments(editComment);
            })
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const deleteComment = async (commentId: string) => {
        try {
            toggleLoading(true);
            await DeleteOpportunitiyPanelCommentsAPI(commentId, company.id).then((resp: IResponseProps) => {
                toast.success(`Comentário deletado com sucesso`);
            }).finally(() => {
                toggleLoading(false);
                const newComments = opportunitiesComments.filter(x => x.id !== commentId);
                setOpportunitiesComments(newComments);
            })
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const getAllCommentsByPanel = async () => {
        try {
            toggleLoading(true);
            let id = opportunitiesPanelsId ?? "";

            await GetAllCommentsByOpportunitiesPanelsIdAPI(id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    setOpportunitiesComments(resp.data);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    useEffect(() => {
        getAllCommentsByPanel();
        getAllGroupedByOrganism();
    }, []);

    useEffect(() => {
        if (opportunitiesPanelsId != "") {
            getOpportunitiesPanelsInfo(opportunitiesPanelsId ?? "");
        }
    }, [opportunitiesPanelsId]);

    return (
        <div className='card ml-2 mr-2'>
            {loading && <Loader />}
            <CardHeader
                pageName={name}
                hasPageBefore={true}
                linkPageBefore={`/opportunitiesPanels/${company.id}`}
                pageBeforeName={"Painel de Oportunidades"}
            />
            <div className='card-body mx-4 pb-0'>
                <CollapseLinesComponent
                    setLoading={(data: boolean) => toggleLoading(data)}
                    grantsLines={grantsLines}
                    projectsByGrant={projectsByGrant} />
            </div>

            <div className='mx-5 mb-2'>
                <div className='w-100 mb-4'>
                    <div className='w-100'>
                        <div className="d-flex justify-content-between align-items-center">
                            <Typography className='m-0  titles' style={{ fontWeight: "600" }}>Aprovação</Typography>
                        </div>
                        <Form
                            form={form}
                            layout="vertical"
                            className="mt-4"
                        >
                            <Form.Item>
                                <div className="d-flex align-items-center mr-2">
                                    <Typography aria-level={6} className='mb-0'>Considerar esta versão do Painel de Oportunidades aprovado?</Typography>
                                    <div className="line-body w-25 ms-2">
                                        <Controller
                                            name="result"
                                            control={control}
                                            defaultValue='2'
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    style={{ height: '40px', width: '320px' }}
                                                    optionFilterProp="label"
                                                    // defaultValue={'2'}
                                                    value={result}
                                                    onChange={value => setResult(value)}
                                                    options={[
                                                        { value: '0', label: 'Não' },
                                                        { value: '1', label: 'Sim' },
                                                        { value: '2', label: 'Pendente' }
                                                    ]}
                                                />
                                            )}
                                        />
                                    </div>
                                </div>
                            </Form.Item>

                            {result !== "2" &&
                                <Form.Item style={{ marginBottom: '0px' }} required tooltip="Por favor, insira o nome do painel!">
                                    <Controller
                                        name="comment"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <div className="d-flex align-items-center mb-4 mr-2">
                                                    <TextArea {...field} placeholder='Escreva aqui o seu comentário...' className='form-control' />
                                                </div>

                                                <div className="d-flex justify-content-end align-items-center mb-4 mr-2">
                                                    <Button
                                                        type='primary'
                                                        className='white'
                                                        onClick={handleSubmit(data => Submit(data))}
                                                    ><Typography aria-level={6} className='p-2 white'>Salvar</Typography></Button>
                                                </div>
                                            </>
                                        )}
                                    />
                                </Form.Item>
                            }
                        </Form>
                    </div>
                    <div className='maxHeight cardComments w-100'>
                        <CommentsPanelsComponent
                            panelComments={
                                opportunitiesComments.sort((a, b) => {
                                    var key1 = a.created;
                                    var key2 = b.created;

                                    if ((isAsc && key1 < key2) || (!isAsc && key1 > key2)) {
                                        return -1;
                                    } else if (key1 == key2) {
                                        return 0;
                                    } else {
                                        return 1;
                                    }
                                })
                            }
                            deleteComments={deleteComment}
                            editComment={editComment}
                            isAsc={isAsc}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LinesPresentation;